const stringSortComparator = (c1, c2) => c1.localeCompare(c2);
const phoneNumberSortComparator = (c1, c2) => {
    return (c1 + '').replace(/\D/g,'').localeCompare((c2 + '').replace(/\D/g,''));
}

const parseIntSortComparator = (c1, c2) => {
    if( parseInt(c1) - parseInt(c2) === 0) {
        return c1 - c2;
    }
    return parseInt(c1) - parseInt(c2);
}

// "Houston, TX 77777", degrading cleanly as parts go missing rather than
// printing "null" / "undefined". city, state and zip are all nullable on
// customers, and the state code is a lookup that misses when state_id is null.
const formatCityStateZip = (city, stateCode, zipCode) => {
    const stateAndZip = [stateCode, zipCode].filter(Boolean).join(' ');
    return [city, stateAndZip].filter(Boolean).join(', ');
}

// P1-13: "08/20/2026" for the report header's service date (spec §4.1), from a
// `timestamp without time zone` as the API sends it ("2026-08-20T14:23:00.000Z").
//
// ⚠ Read off the STRING, deliberately -- do NOT reach for `new Date(...)` here. Those
// columns hold a wall-clock reading with no zone, so the `Z` the serializer appends is
// a fiction, and putting it through Date + Intl.DateTimeFormat converts a value that
// was never in UTC *out of* UTC: a midnight timestamp lands on the previous day
// anywhere west of it. A collection's `start_time` is routinely midnight, so that is
// the ordinary case rather than an edge one. This codebase has already had one
// off-by-one-day bug from exactly this confusion (P1-12, which is why the server
// stamps collected_timestamp now), and the rest of the UI sidesteps it by slicing the
// string -- `start_time?.slice(0, 10)`.
//
// Returns '' rather than a guess for anything unparseable: a blank cell is a visible
// omission, where "01/01/1970" reads as data.
const formatServiceDate = (timestamp) => {
    if (timestamp == null) return '';
    const iso = typeof timestamp.toISOString === 'function'
        ? timestamp.toISOString()
        : String(timestamp);
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    return parts ? `${parts[2]}/${parts[3]}/${parts[1]}` : '';
}

const exports = {
    stringSortComparator,
    phoneNumberSortComparator,
    parseIntSortComparator,
    formatCityStateZip,
    formatServiceDate,
};

export default exports;
export {
    stringSortComparator,
    phoneNumberSortComparator,
    parseIntSortComparator,
    formatCityStateZip,
    formatServiceDate,
};
